import script from "./ContactEffect.vue?vue&type=script&setup=true&lang=js"
export * from "./ContactEffect.vue?vue&type=script&setup=true&lang=js"

import "./ContactEffect.vue?vue&type=style&index=0&id=c0ec04b6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c0ec04b6"]])

export default __exports__